module.exports = __webpack_public_path__ + "static/youcat-logo.b96ffe3f.svg";